import React, { useState } from "react"
import PropTypes from "prop-types"

const PLPDescription = ({ desc = "" }) => {
  const [showMore, setShowMore] = useState(false)

  const descText = desc?.replace(/<[^>]*>/g, "").replace(/[\r\n]/g, "")
  const split = descText.split(".")
  const mainText = split[0]
  split.shift()

  const moreText = split.join(".")
  return (
    <p className="plp-desc">
      {`${mainText}. ${showMore ? moreText : ""} `}
      {moreText ? (
        <button
          className="read-more"
          onClick={() => {
            setShowMore(!showMore)
          }}
        >
          Read {showMore ? "less" : "more"}
        </button>
      ) : null}
    </p>
  )
}

PLPDescription.propTypes = {
  desc: PropTypes.string,
}

export default PLPDescription
